export const traditional = [
  {
    number: 'TR100',
    hasModel: true,
  },
  {
    number: 'TR101',
    hasModel: true,
  },
  {
    number: 'TR102',
    hasModel: true,
  },
  {
    number: 'TR103',
    hasModel: true,
  },
  {
    number: 'TR104',
    hasModel: false,
  },
  {
    number: 'TR105',
    hasModel: true,
  },
  {
    number: 'TR106',
    hasModel: false,
  },
  {
    number: 'TR107',
    hasModel: false,
  },
  {
    number: 'TR108',
    hasModel: false,
  },
  {
    number: 'TR109',
    hasModel: true,
  },
  {
    number: 'TR110',
    hasModel: true,
  },
  {
    number: 'TR111',
    hasModel: true,
  },
  {
    number: 'TR112',
    hasModel: true,
  },
  {
    number: 'TR113',
    hasModel: true,
  },
  {
    number: 'TR114',
    hasModel: false,
  },
  {
    number: 'TR115',
    hasModel: true,
  },
  {
    number: 'TR116',
    hasModel: true,
  },
  {
    number: 'TR117',
    hasModel: true,
  },
  {
    number: 'TR118',
    hasModel: false,
  },
  {
    number: 'TR119',
    hasModel: true,
  },
  {
    number: 'TR120',
    hasModel: true,
  },
  {
    number: 'TR121',
    hasModel: true,
  },
  {
    number: 'TR122',
    hasModel: false,
  },
  {
    number: 'TR123',
    hasModel: false,
  },
  {
    number: 'TR124',
    hasModel: false,
  },
  {
    number: 'TR125',
    hasModel: false,
  },
  {
    number: 'TR126',
    hasModel: false,
  },
  {
    number: 'TR127',
    hasModel: true,
  },
  {
    number: 'TR128',
    hasModel: true,
  },
  {
    number: 'TR129',
    hasModel: true,
  },
  {
    number: 'TR130',
    hasModel: false,
  },
  {
    number: 'TR131',
    hasModel: false,
  },
  {
    number: 'TRX',
    hasModel: false,
  },
];
